
import { apiFetch } from "./api-client";
import type { GetSignedUrlResponse } from "@/dto/index";

// Generate a signed Bunny.net iframe URL via the new API. The backend keys
// the enrollment gate off the lesson's parent course, so lessonId is required.
export const generateBunnyVideoUrl = async (videoGuid: string, lessonId: string): Promise<string> => {
  if (!videoGuid) throw new Error("videoGuid is required");
  if (!lessonId) throw new Error("lessonId is required");

  const data = await apiFetch<GetSignedUrlResponse>(
    `/api/video/signed-url?lessonId=${encodeURIComponent(lessonId)}`
  );

  if (!data?.url) {
    throw new Error("Invalid response from server");
  }

  return data.url;
};
